import { Box } from '@mui/material';

interface Props {
  children: JSX.Element;
  value: number;
  index: 0 | 1 | 2 | 3;
}

const SnapshotAlarmSetupTabPanel = ({
  children,
  value,
  index,
  ...other
}: Props) => {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ maxHeight: '80vh' }}
      {...other}
    >
      {value === index && (
        <Box p={0} component={'span'}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default SnapshotAlarmSetupTabPanel;
